import { render, staticRenderFns } from "./PdfFooter.vue?vue&type=template&id=54224c68&scoped=true"
import script from "./PdfFooter.vue?vue&type=script&lang=js"
export * from "./PdfFooter.vue?vue&type=script&lang=js"
import style0 from "./PdfFooter.vue?vue&type=style&index=0&id=54224c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54224c68",
  null
  
)

export default component.exports